import axios from "axios";
import { API_BASE_PKIX_URL } from "../../../util/constants";

export function requestDownloadIdentityCa(params: any) {
  return axios.request({
    method: "get",
    withCredentials: true,
    url: API_BASE_PKIX_URL + "/download-identity-ca",
    responseType: "blob",
    params: {
      group: params.group,
      thumbPrint: params.thumbPrint,
    },
  });
}
